import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import NREllipsisTooltipStyles from './NREllipsisTooltip.styles';
const useStyles = makeStyles(NREllipsisTooltipStyles);

const NREllipsisTooltip = ({ text, content, maxWidth = 200 }) => {
  const classes = useStyles();
  return (
    <Tooltip title={text}>
      <Typography className={classes.ellipsisText} style={{ maxWidth }} component="span">
        {content ? content : text}
      </Typography>
    </Tooltip>
  );
};

export default NREllipsisTooltip;
